/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentFormatEnum } from './appointmentFormatEnum';
import { TreatmentTypeEnum } from './treatmentTypeEnum';
import { SessionTypeEnum } from './sessionTypeEnum';


/**
 * Serializer for the AppointmentType model with additional fields.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentTypeSerializerDetail { 
    readonly id: number;
    name: string;
    readonly treatmentType: TreatmentTypeEnum;
    readonly sessionType: SessionTypeEnum;
    readonly appointmentFormat: AppointmentFormatEnum;
    lengthInMin: number;
    /**
     * Puffer für Vor-/Nachbereitungszeit am Ende der Sitzung
     */
    postprocessBufferInMin?: number;
}
export namespace AppointmentTypeSerializerDetail {
}

export const AppointmentTypeSerializerDetail_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTypeSerializerDetail_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(127),];

export const AppointmentTypeSerializerDetail_treatmentType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTypeSerializerDetail_sessionType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTypeSerializerDetail_appointmentFormat_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentTypeSerializerDetail_lengthInMin_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.min(-2147483648), Validators.max(2147483647),];

export const AppointmentTypeSerializerDetail_postprocessBufferInMin_Validators: ValidatorFn[] =
    [  Validators.min(-2147483648), Validators.max(2147483647),];


